window.addEventListener('pageshow', function (e) {
  if (e.persisted) {
    window.location.reload();
  }
});

function borneCartShowError(err) {
  var el = document.getElementById('borneCartError');
  if (!el) return;
  el.style.display = 'block';
  el.textContent = 'Erreur panier : ' + (err && err.message ? err.message : String(err));
}

function borneCartInit() {
  try {
    if (!window.KioskCart) {
      borneCartShowError('window.KioskCart introuvable (kiosk-cart.js non chargé)');
      return;
    }

    var currentItems = null;
    var urlParams = new URLSearchParams(window.location.search);
    var cartParam = urlParams.get('cart');
    if (cartParam) {
      currentItems = JSON.parse(decodeURIComponent(atob(cartParam)));
      try {
        window.KioskCart.setItems(currentItems);
      } catch (storageErr) {}
    }

    function formatMoney(amount) {
      return amount.toFixed(2).replace('.', ',') + ' $';
    }

    function renderItems(items) {
      var container = document.getElementById('borneCartItems');
      var printBtn = document.getElementById('bornePrintBtn');
      var total = 0;

      if (!items || items.length === 0) {
        container.innerHTML = '<div class="borne-cart-empty">Votre panier est vide.</div>';
        printBtn.disabled = true;
      } else {
        printBtn.disabled = false;
        container.innerHTML = items.map(function (item) {
          total += item.price * item.quantity;
          return '' +
            '<div class="borne-cart-item" data-id="' + item.id + '">' +
              (item.image ? '<img src="' + item.image + '" alt="">' : '<div style="width:64px;height:64px;background:#eee;border-radius:10px;flex-shrink:0;"></div>') +
              '<div class="borne-cart-item-info">' +
                '<div class="borne-cart-item-title">' + item.title + '</div>' +
                '<div class="borne-cart-item-price">' + formatMoney(item.price) + ' / unité</div>' +
              '</div>' +
              '<div class="borne-cart-item-qty">' +
                '<button type="button" class="borne-qty-minus">−</button>' +
                '<input type="number" class="borne-qty-input" value="' + item.quantity + '" min="1">' +
                '<button type="button" class="borne-qty-plus">+</button>' +
              '</div>' +
              '<button type="button" class="borne-cart-item-remove">✕</button>' +
            '</div>';
        }).join('');
      }

      document.getElementById('borneCartTotal').textContent = formatMoney(total);
    }

    function renderFromStorage() {
      renderItems(window.KioskCart.getItems());
    }

    document.getElementById('borneCartItems').addEventListener('click', function (e) {
      var itemEl = e.target.closest('.borne-cart-item');
      if (!itemEl) return;
      var id = itemEl.dataset.id;
      var input = itemEl.querySelector('.borne-qty-input');

      if (e.target.classList.contains('borne-qty-minus')) {
        var val = parseInt(input.value, 10) || 1;
        window.KioskCart.updateQuantity(id, val - 1);
      } else if (e.target.classList.contains('borne-qty-plus')) {
        var val = parseInt(input.value, 10) || 1;
        window.KioskCart.updateQuantity(id, val + 1);
      } else if (e.target.classList.contains('borne-cart-item-remove')) {
        window.KioskCart.removeItem(id);
      }
      renderFromStorage();
    });

    document.getElementById('borneCartItems').addEventListener('change', function (e) {
      if (!e.target.classList.contains('borne-qty-input')) return;
      var itemEl = e.target.closest('.borne-cart-item');
      var id = itemEl.dataset.id;
      var val = parseInt(e.target.value, 10) || 1;
      window.KioskCart.updateQuantity(id, val);
      renderFromStorage();
    });

    document.getElementById('bornePrintBtn').addEventListener('click', function () {
      var items = window.KioskCart.getItems();
      if (!items || items.length === 0) return;

      var nameInput = document.getElementById('borneCustomerName');
      var phoneInput = document.getElementById('borneCustomerPhone');
      var name = nameInput.value.trim();
      var phone = phoneInput.value.trim();

      if (!name || !phone) {
        alert('Veuillez inscrire votre nom et votre numéro de téléphone avant d\'imprimer.');
        if (!name) nameInput.focus();
        else phoneInput.focus();
        return;
      }

      document.getElementById('printCustomerName').textContent = name;
      document.getElementById('printCustomerPhone').textContent = phone;
      document.getElementById('printDate').textContent = new Date().toLocaleDateString('fr-CA', { year: 'numeric', month: 'long', day: 'numeric' });

      var printTotal = 0;
      document.getElementById('printItemsList').innerHTML = items.map(function (item) {
        var subtotal = item.price * item.quantity;
        printTotal += subtotal;
        return '' +
          '<tr style="border-bottom: 1px solid #ddd;">' +
            '<td style="padding: 8px 0;">' + item.title + (item.sku ? '<br><span style="color:#999;font-size:11px;">SKU : ' + item.sku + '</span>' : '') + '</td>' +
            '<td style="text-align: center; padding: 8px 0;">' + item.quantity + '</td>' +
            '<td style="text-align: right; padding: 8px 0;">' + formatMoney(item.price) + '</td>' +
            '<td style="text-align: right; padding: 8px 0;">' + formatMoney(subtotal) + '</td>' +
          '</tr>';
      }).join('');

      document.getElementById('printTotal').textContent = formatMoney(printTotal);

      function handleAfterPrint() {
        window.removeEventListener('afterprint', handleAfterPrint);

        try { window.KioskCart.clear(); } catch (e) {}
        document.getElementById('borneCustomerName').value = '';
        document.getElementById('borneCustomerPhone').value = '';

        var thankYou = document.getElementById('borne-thank-you');
        thankYou.style.display = 'flex';

        setTimeout(function () {
          window.location.href = '/pages/borne';
        }, 8000);
      }

      var safeName = name.replace(/[\\\/:*?"<>|]/g, '').trim();
      var safePhone = phone.replace(/[\\\/:*?"<>|]/g, '').trim();
      var originalTitle = document.title;
      document.title = safeName + ' - ' + safePhone;

      function restoreTitle() {
        window.removeEventListener('afterprint', restoreTitle);
        document.title = originalTitle;
      }

      window.addEventListener('afterprint', handleAfterPrint);
      window.addEventListener('afterprint', restoreTitle);
      window.print();
    });

    renderItems(currentItems || window.KioskCart.getItems());
  } catch (err) {
    borneCartShowError(err);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', borneCartInit);
} else {
  borneCartInit();
}